<template>
    <div id="mailbox" v-if="IsEmailEnabled()">
        <AppBreadCrumb :paths="[{ title: $t('message.mail') }, ...paths]" :show-trial-remain-day="true" />
        <div id="mailbox-in">
            <MailboxMenu @mailDetail="(e) => (mailDetails = e)" @changeUser="(e) => (selectedUserId = e)" />

            <exampleView v-if="selectedNewTemplate" :userId="user._id" />

            <MailList
                v-if="!selectedNewTemplate"
                @mailDetails="(e) => (mailDetails = e)"
                :selectedUserId="selectedUserId"
            />

            <MailComposer
                :selectedUserId="selectedUserId"
                v-if="selectedNewMail && !selectedNewTemplate"
                :mailDetails="mailDetails"
                @newMailDetail="(e) => (newMailDetail = e)"
                :isNewMail="true"
            />

            <NoMessage
                v-if="!selectedNewMail && mailDetails.length === 0 && !selectedNewTemplate"
                :desc="$t('mail.mailNotFound')"
                newMail="true"
                class="empty-mail"
            />

            <ThreadViewer
                v-if="!selectedNewMail && mailDetails.length > 0 && !selectedNewTemplate"
                :mailDetails="mailDetails"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import { log2 } from "../../../utils/log2";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb";
import MailList from "./MailList";
import MailboxMenu from "./MailboxMenu";
import MailComposer from "./MailComposer.vue";
import ThreadViewer from "./ThreadViewer";
import * as _ from "lodash";
import { newMailSound } from "../../../utils/notificationSounds";
import CONFIG from "../../../config/config";
import exampleView from "./views/Example.vue";
import NoMessage from "./NoMessage.vue";

const log = log2("Mail");
export default {
    name: "Mail",
    components: {
        NoMessage,
        exampleView,
        AppBreadCrumb,
        MailList,
        MailboxMenu,
        MailComposer,
        ThreadViewer,
    },
    props: {},
    data() {
        return {
            paths: [],
            queryAction: this.$route.query.action,
            mailDetails: [],
            newMailDetail: [],
            selectedUserId: "",
            selectedRepresentativeId: "",
        };
    },
    computed: {
        ...mapState({
            userInteracted: (state) => state.app.userInteracted,
            selectedNewMail: (state) => state.mail.selectedNewMail,
            selectedNewTemplate: (state) => state.mail.selectedNewTemplate,
            selectedMenu: (state) => state.mail.selectedMenu,
            selectedDepartment: (state) => state.mail.selectedDepartment,
            selectedMailThreadId: (state) => state.mail.selectedMailThreadId,
            emailNotification: (state) => state.mail.emailNotification,
            emailSendSuccess: (state) => state.mail.emailSendSuccess,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapMutations({
            CHANGE_SELECTED_MENU: "mail/CHANGE_SELECTED_MENU",
            CHANGE_SELECTED_DEPARTMENT: "mail/CHANGE_SELECTED_DEPARTMENT",
            SELECTED_MAIL: "mail/SELECTED_MAIL",
            playEmailNotification: "mail/playEmailNotification",
            SELECTED_NEW_MAIL: "mail/SELECTED_NEW_MAIL",
        }),
        playNotificationSound: _.debounce(function (isReceive = false) {
            newMailSound().play();
        }, 1000),
        IsEmailEnabled() {
            return CONFIG.EMAIL_SERVICE_ENABLED;
        },
    },
    async mounted() {
        const { selected, departmentName, threadId } = this.$route.query;
        if (!!selected) {
            this.CHANGE_SELECTED_MENU(selected);
        } else {
            this.CHANGE_SELECTED_MENU("My");
            this.paths = [{ title: "My" }];
            this.$router.replace({
                query: { ["selected"]: encodeURI("My") },
            });
        }
        if (!!departmentName) {
            this.CHANGE_SELECTED_DEPARTMENT(departmentName);
        } else {
            this.CHANGE_SELECTED_DEPARTMENT("");
        }
        if (!!threadId) {
            this.SELECTED_MAIL(threadId);
        } else {
            this.mailDetails = [];
        }
        if (this.queryAction === "create") this.SELECTED_NEW_MAIL(true);

        window.addEventListener("keydown", (e) => {
            if ("Escape" === e.key || "Esc" === e.key) {
                this.mailDetails = [];
                this.SELECTED_NEW_MAIL(false);
            }
        });
    },
    watch: {
        selectedRepresentativeId(val) {
            console.log("watch selectedRepresentativeId", val);
        },
        newMailDetail(val) {
            this.mailDetails = [val];
        },
        emailNotification(val) {
            if (val === true) {
                this.$message.success("Yeni mail geldi.", 3);
                if (this.userInteracted) {
                    this.playNotificationSound();
                }
                this.playEmailNotification(false);
            }
        },
        emailSendSuccess(val) {
            this.$message.destroy();
            this.$message.success("Mail başarıyla gönderildi.", 3);
        },
        selectedMenu(val) {
            if (!!val) {
                this.paths = [{ title: val }];
                this.$router.replace({
                    query: { ["selected"]: encodeURI(val) },
                });
            }
        },
        selectedDepartment(val) {
            if (val === "" || val === undefined) return;
            this.paths = [{ title: this.selectedMenu }, { title: val }];
            this.$router.replace({
                query: { ["selected"]: encodeURI("department"), ["departmentName"]: encodeURI(val) },
            });
        },
        selectedMailThreadId(val) {
            if (this.selectedMenu === "department") {
                this.paths = [{ title: this.selectedMenu }, { title: this.selectedDepartment }, { title: val }];
            } else {
                this.paths = [{ title: this.selectedMenu }, { title: val }];
            }
            let query = Object.assign({}, this.$route.query);
            this.$router.replace({
                query: { ...query, ["threadId"]: encodeURI(val) },
            });
        },
    },
};
</script>

<style lang="scss">
#mailbox {
    background-color: #ffffff;

    #mailbox-in {
        display: flex;
        position: relative;
        height: calc(100vh - 93px);
        width: 100%;

        .empty-mail {
            justify-content: center;
            width: 100%;
            display: flex;
            align-items: center;
        }

        .mail-composer {
            width: 100%;
            border-right: 1px solid var(--color-border-default);
        }
    }
}
</style>
